import React, { FC, useState } from 'react';

import { useApi, useFetchData } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';

import { useColumns } from './columns';
import EditDMPType from './edit';
import Error404 from '../../errors/404';

export const DMPTypesTable: FC = () => {
  const hasPermission = usePermissions({
    roles: [ROLES.ADMIN, ROLES.CHIEF],
  });
  const api = useApi();
  const [fetchData] = useFetchData<EntityBase>({ method: api.stands.getDMPTypes });

  const [editOpen, setEditOpen] = useState(false);
  const [operatedVar, setOperatedVar] = useState<EntityBase>();

  const columns = useColumns({
    onEdit: (route: EntityBase) => {
      setOperatedVar(route);
      setEditOpen(true);
    }
  });

  const onClose = () => {
    setEditOpen(false);
  };


  if (!hasPermission) {
    return <Error404/>;
  }

  return (
    <>
      <QueryTable
        title="Типы ДМП"
        columns={columns}
        onCreateClick={() => {
          setOperatedVar(undefined);
          setEditOpen(true);
        }}
        fetchData={fetchData}
        canDownload
      >
        <EditDMPType open={editOpen} setOpen={onClose} initial={operatedVar} />
      </QueryTable>
    </>
  );
};
